<template>
  <div class="component-alert container">
    <div style="max-width: 300px;margin: auto">
      <el-alert
          :title="message"
          :type="type"
          :description="description"
          show-icon>
      </el-alert>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    description: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'warning'
    },
    duaration: {
      type: Number,
      default: 10000
    }
  },
  methods: {
    close () {
      this.$destroy()
    }
  },
  mounted () {
    var timer = setTimeout(() => {
      clearTimeout(timer)
      this.close()
    }, this.duaration)
  },
  destroyed () {
    this.$el.remove()
  }
}
</script>

<style>
.component-alert {
  position: fixed;
  top: 10px;
  left: 0;
  right: 0;
  height: 0;
  z-index: 1050;
  text-align: center;
}
.component-alert > .alert {
  display: inline-block;
}
.component-alert .close {
  position: relative;
  right: -6px;
}
</style>
